export const AUTH_TOKEN = "AUTH_TOKEN";
export const PERSONAL_INFO_DIALOG_OPEN = "PERSONAL_INFO_DIALOG_OPEN";
export const MENU_DRAWER_OPEN = "MENU_DRAWER_OPEN";
export const SET_TABLE_SETTINGS = "SET_TABLE_SETTINGS";
export const SET_SNACKBAR_SETTINGS = "SET_SNACKBAR_SETTINGS";
export const ADMIN_OVERVIEW = "ADMIN_OVERVIEW";
export const ENQUIRY = "ENQUIRY";
export const ENQUIRIES = "ENQUIRIES";
export const ENQUIRY_DETAILS_DIALOG_OPEN = "ENQUIRY_DETAILS_DIALOG_OPEN";
export const QUOTE = "QUOTE";
export const QUOTES = "QUOTES";
export const QUOTE_DETAILS_DIALOG_OPEN = "QUOTE_DETAILS_DIALOG_OPEN";
export const TOUR = "TOUR";
export const TOURS = "TOURS";
